import { render, staticRenderFns } from "./KabJoin.vue?vue&type=template&id=3807b6ae&scoped=true&"
import script from "./KabJoin.vue?vue&type=script&lang=js&"
export * from "./KabJoin.vue?vue&type=script&lang=js&"
import style0 from "./KabJoin.vue?vue&type=style&index=0&id=3807b6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807b6ae",
  null
  
)

export default component.exports